<template>
  <div class="filterSprites" :class="classes">
    <div
      v-if="previewData"
      class="dataBox"
      @click="stopDocument($event)"
    >
      <div
        class="titleTop"
        @click="
          openBodyBox = !openBodyBox;
          openPayTypeBox = false;
        "
      >
        <span>{{getPreviewDataName()}}</span>
        <i class="triang el-icon-caret-bottom" :class="{active: openBodyBox}"></i>
        <!-- <i class="el-icon-caret-bottom" :class="{active: openBodyBox}"></i> -->
      </div>

      <div
        class="bodyBox"
        :class="{
          'bodyBoxAction': openBodyBox,
        }"
      >
        <div
          :class="{
            'boxAction' : !value.fileType,
          }"
          @click="
            selectFillType();
            materialPushAnalysis({type: 'filterSpritesall'});
          "
        >
          全部素材
        </div>

        <div
          v-for="(item, index) in previewData"
          :key="index"
          @click="
            selectFillType(item.data);
            materialPushAnalysis({type: 'filterSprites' + item.type});
          "
          :class="{
            'boxAction' : value.fileType == item.data,
          }"
        >
          {{item.name}}
        </div>
      </div>
    </div>

    <div class="dataBox dataBoxFill" @click="stopDocument($event)">
      <div
        class="titleTop"
        style="text-indent: -1em;"
        @click="
          openPayTypeBox = !openPayTypeBox;
          openBodyBox = false;
        "
      >
        {{value && value.payType ? (value.fileType > 0 ? '全部' : boxPayTypeTitleFS()) : '权限'}}
        <i class="triang el-icon-caret-bottom" :class="{active: openPayTypeBox}"></i>
        <!-- <i class="el-icon-caret-bottom" :class="{active: openPayTypeBox}"></i> -->
      </div>

      <div
        class="bodyBox"
        :class="{
          'bodyBoxAction': openPayTypeBox,
        }"
      >
        <div
          :class="{
            'boxAction' : !(value && value.payType),
          }"
          @click="
            selectPayType(-1);
          "
        >
          全部
        </div>

        <div
          v-for="(item, index) in openPayTypeData"
          :key="index"
          @click="
            selectPayType(item.type);
          "
          :class="{
            'boxAction' : value && value.payType == item.type,
          }"
        >
          {{item.name}}
        </div>
      </div>
    </div>

    <div
      class="searchOutMsg"
      v-if="!loading && (value && !value.data.length)"
    >
      <div class="textBox" v-if="boxName === 'template'">
        此分类中没有模板哦～
      </div>
      <div class="textBox" v-else>
        此分类中没有{{this.value.fileType ? boxTitleFS() : '全部素材'}}哦～
      </div>
      <div>
        <div
          class="butAllSprites"
          @click="showAll();"
        >{{boxName === 'template' ? '查看所有模板' : '查看所有素材'}}</div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Analysis from '../../../mixins/analysis/materialBu';

export default {
  mixins: [Analysis],
  model: {
    prop: 'value', // 绑定的值，通过父组件传递
    event: 'updatefilterSprites' // 自定义事件名
  },
  props: ['value', 'previewData', 'cgid', 'boxName', 'dataArray', 'loading', 'classes', 'previewDataName'],
  data () {
    return {
      boxTitle: '',
      openBodyBox: false,
      openPayTypeBox: false,
      openPayTypeData: [
        {
          name: '免费',
          type: 0
        },
        {
          name: '会员专属',
          type: 4
        }
      ]
    };
  },
  watch: {
  },
  mounted () {
    this.$bus.on('window_click', data => {
      this.openBodyBox = false;
      this.openPayTypeBox = false;
    });
    let vipData;
    switch (this.boxName) {
      case 'sound':
        vipData = [
          {
            name: '免费',
            type: 0
          },
          {
            name: '付费',
            type: 1
          },
          {
            name: '会员专属',
            type: 4
          }
        ];
        this.openPayTypeData = vipData;
        break;
      case 'template':
        vipData = [
          {
            name: '免费',
            type: 0
          },
          {
            name: '付费',
            type: 1
          }
          // {
          //   name : '会员专属',
          //   type : 4,
          // },
        ];
        this.openPayTypeData = vipData;
        break;

      case 'bg':
      case 'props':
        vipData = [
          {
            name: '免费',
            type: 0
          },
          {
            name: '付费',
            type: 1
          },
          {
            name: '会员专属',
            type: 4
          }
        ];
        this.openPayTypeData = vipData;
        break;
    }
  },
  methods: {
    boxTitleFS () {
      for (let i = 0; i < this.previewData.length; i++) {
        if (this.value.fileType && this.previewData[i].data == this.value.fileType) {
          return this.previewData[i].name;
        }
      }
    },
    showAll () {
      this.$bus.emit('filterSpritesJudge', {
        id: this.cgid,
        boxName: this.boxName
      });
      this.openBodyBox = false;
      this.openPayTypeBox = false;
    },
    selectFillType (data) {
      if (this.loading) return;
      let emitData = {
        fileType: data,
        id: this.cgid,
        boxName: this.boxName
      };
      if (this.value && this.value.payType) {
        emitData.payType = this.value.payType;
      }
      this.$bus.emit('filterSpritesJudge', emitData);
      this.openBodyBox = false;
      this.openPayTypeBox = false;

      if (this.boxName === 'template') {
        this.selectPayType(-1);
      }
    },
    boxPayTypeTitleFS () {
      for (let i = 0; i < this.openPayTypeData.length; i++) {
        if (this.value && this.value.payType && this.openPayTypeData[i].type == this.value.payType) {
          return this.openPayTypeData[i].name;
        }
      }
    },
    selectPayType (data) {
      if (this.loading) return;

      let emitData = {
        id: this.cgid,
        boxName: this.boxName
      };
      if ('fileType' in this.value) {
        emitData.fileType = this.value.fileType;
      }
      if (data >= 0) {
        emitData.payType = data;
      }
      this.$bus.emit('filterSpritesJudge', emitData);
      this.openBodyBox = false;
      this.openPayTypeBox = false;
    },
    stopDocument (e) { // 防止事件冒泡
      e.stopPropagation();
      e.preventDefault();
    },
    getPreviewDataName () {
      const vm = this;
      return 'fileType' in vm.value ? (vm.value.fileType ? vm.boxTitleFS() : '全部素材') : (vm.previewDataName || '类型');
    }
  },
  components: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .filterSprites{
    width: 270px;
    height: 30px;
    padding: 2px 0;
    transition: all 0.3s;
    position: absolute;
    top: 25px;
    left: 0px;
    z-index: 150;
    display: flex;
    justify-content: space-between;

    &.no-transition {
      transition: none;
    }

    .dataBox{
      width: 120px;
      height: 36px;
      position: relative;

      >div{
        width: 120px;
        height: 36px;
        background: #fff;
        text-align: center;
        line-height: 36px;
        color: #474261;
        position: absolute;
      }
      .titleTop{
        border: 1px solid #d7dce9;
        border-radius: 5px;
        top: -3px;
        left: 0;
        z-index: 10;
        cursor: pointer;

        i{
          position: absolute;
          // top: 5px;
          right: 10px;
          font-size: 22px;
        }

        &:hover{
          background: #f0f0f9;
        }
      }
      .bodyBox{
        top: 0px;
        left: 0;
        height: 0;
        border: 1px solid #f0f0f9;
        border-radius: 5px;
        opacity: 0;
        transition: all 0.3s;
        z-index: 5;
        overflow: hidden;

        >div{
          cursor: pointer;
          font-size: 14px;
        }

        >div:hover{
          background: #f0f0f0;
        }
        .boxAction{
          background: #f0f0f9!important;
        }
      }

      .bodyBoxAction{
        top: 35px!important;
        height: auto!important;
        opacity: 1!important;
      }
    }
    .dataBoxFill{

    }
    .searchOutMsg{
      position: absolute;
      // top: 60px; 增加了查看更多按钮，留给这里的高度变小了
      top: 47px;
      left: 0;
      z-index: 0;
      width: 100%;
      height: 70px;

      .textBox{
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #474261;
        padding-bottom: 10px;
      }
      .butAllSprites{
        margin: 0 auto;
        width: 120px;
        height: 36px;
        background-color: #d9d9e2;
        border-radius: 4px;
        font-size: 14px;
        color: #474261;
        line-height: 36px;
        cursor: pointer;
        transition: all 0.3s;


        &:hover{
          background: #ededf6;
          color: #5f597d;
        }
      }
    }
  }
  .filterSprites.small {
    top: 0;
    .dataBox {
      margin-left: 158px;

      .titleTop {
        width: 111px;
      }
      .bodyBox {
        width: 111px;
      }
    }
  }
  .filterSprites.sound {
    &  .titleTop > span {
      margin-left: -1.5em;
    }
  }

  @import '../../../../style/_triangle';
  .triang {
    &:before {
      display: none;
    }
    top: 14px;
    @include triangle(bottom, 6px, 8px, #000);
    transition-duration: 0.3s;

    &.active {
      transform: rotate(-180deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/search/filterSprites.vue